<template>
  <v-toolbar
    color="primary"
    fixed
    dark
    app
    >
    <v-toolbar-title class="ml-0 pl-3">
      <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
    </v-toolbar-title>
      <v-spacer></v-spacer>
      {{ adminName }}
      <v-btn icon @click="handleFullScreen()">
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-menu offset-y origin="center center" class="elelvation-1" :nudge-bottom="14" transition="scale-transition">
        <v-btn icon flat slot="activator">
        <v-badge color="red" overlap>
          <span v-if="logNotification.length > 0"  slot="badge">{{logNotification.length}}</span>
          <v-icon medium>notifications</v-icon>
        </v-badge>
        </v-btn>
        <notification-list></notification-list>
      </v-menu>
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon large flat slot="activator">
          <v-icon>account_circle</v-icon>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile
                  v-for="(item,index) in items"
                  :to="!item.href ? { name: item.name } : null"
                  :href="item.href"
                  @click="item.click"
                  ripple="ripple"
                  :disabled="item.disabled"
                  :target="item.target"
                  rel="noopener"
                  :key="index"
          >
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
  </v-toolbar>
</template>
<script>
import NotificationList from '@/components/widgets/list/NotificationList';
import Util from '@/util';
export default {
  name: 'app-toolbar',
  components: {
    NotificationList
  },
  data: () => ({
    items: [
      {
        icon: 'account_circle',
        href: '#',
        title: 'Профиль',
        click: (e) => {
          console.log(e);
        }
      },
      {
        icon: 'settings',
        href: '#',
        title: 'Настройки',
        click: (e) => {
          console.log(e);
        }
      },
      {
        icon: 'close',
        href: '#',
        title: 'Выход',
        click: (e) => {
          window.getApp.$emit('APP_LOGOUT');
        }
      }
    ],
  }),
  computed: {
      toolbarColor () {
        return this.$vuetify.options.extra.mainNav;
      },
      adminName () {
          return this.$store.getters['auth/adminFullname'];
      },
      logNotification() {
        let newLogError = this.$store.getters['log/logData'].filter(item => this.$store.getters['log/logFirstData'].findIndex(iItem => iItem.id == item.id)  == -1 );
        newLogError =  newLogError.filter(item => item.typeLogId == 1); 
        return newLogError;
      }
  },
  methods: {
    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppToolbar.vue